import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core'; // ###
import { MaterialModule } from '../../material.module';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkLib } from '../../services/jkCommon';
import { idNameItem } from '../../services/jkInterface';


@Component({
  selector: 'app-tag',
  standalone: true,
  //templateUrl: './tag.component.html',
  template: `<span class="tag">
  {{ label() }}
  <button (click)="remove()">x</button>
  </span>
  `,
  //styleUrls: ['./tag.component.css']
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`.tag {
    display: inline-block;
    padding: 4px 8px;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-right: 4px;
  }`,
  ` button {
    border: none;
    background: none;
    cursor: pointer;
  }`]
})
export class TagComponent {
  readonly label = input<string>('');
  readonly removed = output<void>();

  remove() {
    this.removed.emit();
  }
}

@Component({
    selector: 'app-jktagbox',
    templateUrl: './jktagbox.component.html',
    styleUrls: ['./jktagbox.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [JkfieldlabelComponent,TagComponent,MaterialModule,],
})
export class JktagboxComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jktagbox';
  readonly enabled = input(true);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() items: any[] = []; // idNameItem[] = [];
  readonly valueExpr = input<string>('id');
  readonly displayExpr = input<string>('name');
  //@Input() width: number = 200;
  readonly value = input<string[]>([]);
  readonly valueChange = output<string[]>();
  //onValueChange(newValue: string[]) {
  /*onValueChange(event: string[]) {
    if(event.target){
      let newValue = (event.target as HTMLInputElement).value.split(',');
      if(this.valueChange) this.valueChange.emit(newValue);
    }
  }*/
  onValueChange(event: string[]) {

      if(this.valueChange) this.valueChange.emit(event);
  }


  constructor() {
    super();
    this.width.set(200);
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string='id'): string {
    const value = this.value();
    if(value){
      where = jkLib.array2Where(value, where,fieldName);
    }
    return where;
  }
  remove(item:idNameItem) {
    this.items = this.items.filter(i => i !== item);
  }
}
